<div class="app-menu navbar-menu">
    <!--style=" height: 60px;" [ngStyle] = "{'height': (this.innerWidth >= 1025) ? '60px': '33vh' } "  -->
    <!-- LOGO -->
    <div class="navbar-brand-box">
        <!-- Dark Logo-->
        <a routerLink="" class="logo logo-dark">
            <span class="logo-sm">
                <img src="assets/myfile/Favicon-Black-Noborder-Transparent.png" alt="" height="30">
            </span>
            <span class="logo-lg">
                <img src="assets/myfile/MyFileName-Black-Transparent.png" alt="" height="50">
            </span>
        </a>
        <!-- Light Logo-->
        <a routerLink="" class="logo logo-light">
            <span class="logo-sm">
                <img src="assets/myfile/Favicon-White-Noborder-Transparent.png" alt="" height="30">
            </span>
            <span class="logo-lg">
                <img src="assets/myfile/MyFileName-White-Transparent.png" alt="" height="50">
            </span>
        </a>
        <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover">
            <i class="ri-record-circle-line"></i>
        </button>
    </div>

    <div id="scrollbar">
        <div class="container-fluid ">

            <div id="two-column-menu">
            </div>
            <ul class="navbar-nav" id="navbar-nav"> <!--  style="width:100%; overflow: scroll;" -->
                <ng-container *ngFor="let item of menuItems">
                    <li class="menu-title" *ngIf="item.isTitle"><span data-key="t-menu">{{ item.label }}</span> </li>

                    <li class="nav-item" *ngIf="!item.isTitle && !item.isLayout && item.isVisible">

                        <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent nav-link menu-link "
                            style="width:max-content" data-bs-toggle="collapse" aria-expanded="false"
                            (click)="toggleItem($event)">

                            <i class="{{ item.icon }} icon nav-icon" class=""></i>
                            <span class=""> <span *ngIf="item.badge && item.badge.visible"
                                    class="position-absolute fs-10 translate-middle badge rounded-pill {{item.badge.variant}}">
                                    {{item.badge.text}} </span> {{ item.label }}</span>

                        </a>

                        <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref nav-link menu-link"
                            style="width:max-content ">
                            <span>
                                <span *ngIf="item.badge && importCount && importCount.count >0"
                                    class="position-absolute fs-10 translate-middle badge rounded-pill {{item.badge.variant}}">{{importCount.count}}</span>
                                <i class="bx {{ item.icon }} icon nav-icon" *ngIf="item.icon" class="">
                                </i>
                            </span>
                            <span class=""> {{ item.label }}</span>

                        </a>
                        <div class="collapse menu-dropdown box-shadow" id="sidebarDashboards" *ngIf="hasItems(item) ">
                            <!-- style="overflow: visible;  position: sticky; " -->
                            <ul *ngIf="hasItems(item)" class="nav nav-sm flex-column" aria-expanded="false">
                                <ng-container *ngFor="let subitem of item.subItems">
                                    <li *ngIf="subitem.isVisible" class="nav-item">

                                        <a [routerLink]="subitem.link" *ngIf="!hasItems(subitem)" class="nav-link " style="cursor: pointer;"
                                            [attr.data-parent]="subitem.parentId"
                                            (click)="updateActive($event, subitem.modalType); openOutwardLink(subitem.outwardlink)">
                                            <span class="d-flex ">
                                                <i class="bx {{ subitem.icon }} icon nav-icon" *ngIf="subitem.icon"
                                                    class=""></i>
                                                <span>
                                                    {{ subitem.label }}
                                                    <span class="badge badge-pill {{subitem.badge.variant}}"
                                                        *ngIf="subitem.badge && subitem.badge.visible">{{subitem.badge.text
                                                        }}</span>
                                                </span>
                                            </span>

                                        </a>

                                        <a *ngIf="hasItems(subitem)" class="nav-link" href="javascript:void(0);"
                                            [attr.data-parent]="subitem.parentId" data-bs-toggle="collapse"
                                            aria-expanded="false" (click)="toggleSubItem($event)">
                                            <i class="bx {{ subitem.icon }} icon nav-icon" *ngIf="subitem.icon"
                                                class=""></i>{{ subitem.label }}
                                        </a>

                                        <div class="collapse menu-dropdown" *ngIf="hasItems(subitem)">
                                            <ul class="nav nav-sm flex-column" aria-expanded="false">
                                                <ng-container *ngFor="let subSubitem of subitem.subItems">
                                                    <li *ngIf="subSubitem.isVisible" class="nav-item">
                                                        <a [attr.data-parent]="subSubitem.parentId"
                                                            [routerLink]="subSubitem.link" *ngIf="!subSubitem.childItem"
                                                            class="nav-link" (click)="updateActive($event)">
                                                            {{ subSubitem.label }}
                                                        </a>

                                                        <a [attr.data-parent]="subSubitem.parentId"
                                                            [routerLink]="subSubitem.link" data-bs-toggle="collapse"
                                                            aria-expanded="false" *ngIf="subSubitem.childItem"
                                                            class="nav-link" (click)="updateActive($event)">
                                                            {{ subSubitem.label }}
                                                        </a>

                                                        <div class="collapse child menu-dropdown"
                                                            *ngIf="haschildItems(subSubitem)">
                                                            <ul class="nav nav-sm flex-column" aria-expanded="false">
                                                                <ng-container
                                                                    *ngFor="let subChilditem of subSubitem.childItem">
                                                                    <li *ngIf="subChilditem.isVisible" class="nav-item">
                                                                        <a [attr.data-parent]="subSubitem.parentId"
                                                                            [routerLink]="subChilditem.link"
                                                                            class="nav-link"
                                                                            (click)="updateActive($event)">
                                                                            {{ subChilditem.label }}
                                                                        </a>
                                                                    </li>
                                                                </ng-container>
                                                            </ul>
                                                        </div>

                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </li>
                                </ng-container>
                            </ul>

                        </div>
                    </li>
                </ng-container>

            </ul>
            <!-- Right Side Bar -->
            <app-rightsidebar></app-rightsidebar>
        </div>
        <!-- Sidebar -->

    </div>
</div>